export default __webpack_public_path__ + "static/ausfluege-0ab5bea3a4b261633453c4e486361220.png";